import { useMemo } from 'react';
import { useMatches } from 'react-router';
// oxlint-disable-next-line no-restricted-imports -- TODO(zod-4): migrate to 'zod/v4'
import { z } from 'zod';

const viewsSchema = z.object({
  Views: z.function().returns(z.any()),
});

/**
 * Render an views for the current route.
 *
 * A route defines its views via its `handle`.
 */
export function Views() {
  const matches = useMatches();

  const RouteViews = useMemo(() => {
    const reversedMatches = [...matches].reverse();

    for (const match of reversedMatches) {
      const parse = viewsSchema.safeParse(match.handle);
      if (parse.success) {
        return parse.data.Views;
      }
    }
    return undefined;
  }, [matches]);

  if (RouteViews === undefined) {
    return null;
  }

  return (
    <div>
      <RouteViews />
    </div>
  );
}
